export default __webpack_public_path__ + "static/media/img10.e67af190.jpeg";